import React, {PropTypes as T} from 'react';
import withDevice from '../../common/withDeviceHOC';
import translate from '../../../utils/translate';
import fullScreenActions from '../../../actions/fullscreen';

export class MapHeader extends React.Component {
  static propTypes = {
    label:          T.string,
    toggleFilters:  T.func,
    isFilterActive: T.bool,
    isMobile:       T.bool
  };

  closeFullScreen = () => {
    fullScreenActions.unfix();
  };

  toggleFilters = () => {
    if (typeof this.props.toggleFilters === 'function') {
      this.props.toggleFilters();
    }
  };

  renderHeaderContent = () => {
    if (this.props.isMobile) {
      const toggleClass = this.props.isFilterActive
      ? 'pricefilter__toggle is-active'
      : 'pricefilter__toggle';

      return (
        <button className={toggleClass} onClick={this.toggleFilters}>
          <span>{this.props.label}</span>
        </button>
      );
    }
    else {
      return (
        <h2 className="map__header__title">
          {translate('pageTranslations', 'PICK_YOUR_SEATS')}
        </h2>
      );
    }
  };

  render () {
    const buttonText = translate('pageTranslations', 'CLOSE_FULL_SCREEN_MAP');
    return (
      <header className="map__header">
        <div className="map__header__content">
          {this.renderHeaderContent()}
        </div>
        <button
          className="map__header__close"
          onClick={this.closeFullScreen} title={buttonText}
          data-component="close-full-screen">
          <span className="map__header__close__txt">{buttonText}</span>
        </button>
      </header>
    );
  }
}

export default withDevice(MapHeader);



// WEBPACK FOOTER //
// ./frontend/react/components/edp/header/index.js